import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
export var ClipboardLoader = /*#__PURE__*/function (_React$PureComponent) {
  function ClipboardLoader() {
    var _this;
    _classCallCheck(this, ClipboardLoader);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ClipboardLoader, [].concat(args));
    _defineProperty(_this, "state", {
      Clipboard: ClipboardLoader.Clipboard
    });
    return _this;
  }
  _inherits(ClipboardLoader, _React$PureComponent);
  return _createClass(ClipboardLoader, [{
    key: "UNSAFE_componentWillMount",
    value: function () {
      var _UNSAFE_componentWillMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _yield$Promise$all, _yield$Promise$all2, mediaClient, clipboardModule;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.state.Clipboard) {
                _context.next = 9;
                break;
              }
              _context.next = 3;
              return Promise.all([import( /* webpackChunkName: "@atlaskit-internal_media-client-react" */'@atlaskit/media-client-react'), import( /* webpackChunkName: "@atlaskit-internal_media-clipboard" */'./clipboard')]);
            case 3:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              mediaClient = _yield$Promise$all2[0];
              clipboardModule = _yield$Promise$all2[1];
              // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
              ClipboardLoader.Clipboard = mediaClient.withMediaClient(clipboardModule.Clipboard);
              this.setState({
                Clipboard: ClipboardLoader.Clipboard
              });
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function UNSAFE_componentWillMount() {
        return _UNSAFE_componentWillMount.apply(this, arguments);
      }
      return UNSAFE_componentWillMount;
    }()
  }, {
    key: "render",
    value: function render() {
      if (!this.state.Clipboard) {
        return null;
      }
      return /*#__PURE__*/React.createElement(this.state.Clipboard, this.props);
    }
  }]);
}(React.PureComponent);
_defineProperty(ClipboardLoader, "displayName", 'AsyncClipboard');